export default "__VITE_ASSET__DjCAn1vw__"